export default {
  token: null,
  user: {},
  userId: '',
  profile: {},
};
